import { Component, ReactNode } from 'react';

import { Dialog } from '@goshippo/libraries/Dialog';

import { Error } from '@mui/icons-material';
import { Button, Stack, Typography } from '@mui/material';
import { Translation } from 'react-i18next';

import { Code } from '~/src/app/components/Code.tsx';
import { newRelic } from '~/src/clients/newRelic/NewRelicClient';
import { Details } from '~/src/components/Details';

type Props = {
  children?: ReactNode;
};

type State = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
  hasError: boolean;
};

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      error: null,
      hasError: false,
    };
  }

  static getDerivedStateFromError(error: Error) {
    return {
      error: error.toString(),
      hasError: true,
    };
  }

  componentDidCatch(error: Error) {
    newRelic.noticeError(error, { id: 'ErrorBoundary-error' });
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <Dialog
        actions={[
          <Button color="secondary" key={0} onClick={() => location.reload()} variant="text">
            Refresh
          </Button>,
        ]}
        content={
          <Stack gap={2}>
            <Translation>{(t) => t('errorDialog.message')}</Translation>

            <Details title={<Translation>{(t) => t('errorDialog.details')}</Translation>}>
              <Code>{this.state.error}</Code>
            </Details>
          </Stack>
        }
        title={
          <Stack alignItems="center" direction="row" gap={1}>
            <Error color="error" />

            <Typography variant="h2">
              <Translation>{(t) => t('errorDialog.title')}</Translation>
            </Typography>
          </Stack>
        }
        onClose={() => location.reload()}
        open
      />
    );
  }
}
